export class CoreListItem<ItemType extends CoreSingleItem> {
    public getItemByKey(key: string) {
        var item = this.getItems().filter(i => i.key === key)[0];
        
        if(item) {
            return item;
        }

        return undefined;
    }

    public getItems(): ItemType[] {
        throw new Error('getItems must be implemented');
    }
}

export class CoreSingleItem {
    key: string;
}